import {BehaviorSubject} from 'rxjs';
import {distinctUntilChanged, filter, map} from 'rxjs/operators';
import {utaState$} from '@/config';
import {userInfoMsg$} from '@/raw/users';
import {uiMsg$} from '@/ui';
import type {UserInfo} from '@/types';

export interface FUInitUserData {
  type: 'init-user-data';
  data: UserInfo;
}

export {utaState$};

export const isUtaSpot$ = utaState$.pipe(
  map((o) => o.spot === 2),
  distinctUntilChanged()
);

const userLendingAccountInfo$ = new BehaviorSubject({status: 0});
export const isActivateLendingAccount$ = userLendingAccountInfo$.pipe(
  map((o) => o.status === 1),
  distinctUntilChanged()
);

uiMsg$.pipe(filter((o) => o.type === 'init-user-data')).subscribe((o: FUInitUserData) => {
  if (!o.data) {
    return;
  }
  if (o.data.uta) {
    utaState$.next(o.data.uta);
  }
  if (o.data.lendingAccount) {
    userLendingAccountInfo$.next(o.data.lendingAccount);
  }
});

userInfoMsg$
  .pipe(
    filter(
      (o) =>
        (o.bizType === 'ACCOUNT' && o.bizChangeType === 'ACCOUNT_UPGRADE') ||
        (o.bizType === null && o.bizChangeType === null)
    ),
    map((o) => o.content.uta)
  )
  .subscribe((utaState) => {
    if (utaState) {
      utaState$.next(utaState);
    }
  });

userInfoMsg$
  .pipe(
    filter(
      (o) =>
        (o.bizType === 'ACCOUNT' && o.bizChangeType === 'LENDING_ACCOUNT_OPEN') ||
        (o.bizType === null && o.bizChangeType === null)
    ),
    map((o) => o.content.lendingAccount)
  )
  .subscribe((lendingAccount) => {
    if (lendingAccount) {
      userLendingAccountInfo$.next(lendingAccount);
    }
  });
